<!--
 * @Description: 综合结果申报
 * @Author: maqinghe 
 * @Date: 2023年06月06日 13:04:59
-->
<template>
  <div class='declare-page atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search-wrap'>
        <el-form :inline="true" :model="declareForm" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
            <!-- <el-form-item class="form-param-item" label="上级">
              <selecter v-model="declareForm.SuperiorNo" clearable></selecter>
            </el-form-item> -->
            <el-form-item class="form-param-item" label="姓名">
              <selecter v-model="declareForm.wkNo" clearable></selecter>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <el-form-item v-if="!isApprove">
              <el-button type="export" @click="commitTip">提交</el-button>
            </el-form-item>
            <el-form-item v-if="!isApprove">
              <el-button type="refuse" @click="showRevert = true">撤回</el-button>
            </el-form-item>
            <el-form-item v-if="!isApprove">
              <el-button type="downloadTemplate" @click="showApproveReason = true">审批意见</el-button>
            </el-form-item>
            <el-form-item v-if="isApprove">
              <el-button :disabled="this.role == 2" type="primary" @click="showAccess = true">通过</el-button>
            </el-form-item>
            <el-form-item v-if="isApprove">
              <el-button :disabled="this.role == 2" type="refuse" @click="showRefuse = true">驳回</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" plain @click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>
      </div>
      <div class="summary">
        <span class="item-data">当期参评人数:<span class="num">{{currentSum.totalCount||0}}</span></span>
        <span class="item-data">当期应得A人数:<span class="num">{{currentSum.regulationACurrentAll||0}}</span></span>
        <span class="item-data">当期应得C人数:<span class="num">{{currentSum.regulationCCurrentAll||0}}</span></span>
        <span class="item-data">实际当期得A人数:<span :class="currentSum.realityACurrentAll > currentSum.regulationACurrentAll? warnNum : nomalNum">{{currentSum.realityACurrentAll||0}}</span></span>
        <span class="item-data">实际当期得C人数:<span :class="currentSum.realityCCurrentAll < currentSum.regulationCCurrentAll? warnNum : nomalNum">{{currentSum.realityCCurrentAll||0}}</span></span>
        <span class="item-data" style="color:#fe6562">（注意：评级结果为A或C时必须填写评级原因！）</span>
      </div>
      <div class="table-tabs">
        <div
          class="table-tab"
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{'table-tab--active': currentTab === tab.value}"
          @click="switchTab(tab.value)"
        >
          {{ tab.name }}
        </div>
      </div>
      <div class='table-content' v-show="currentTab === 0">
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table"
          :edit-rules="validRules"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" min-width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="185" title="姓名">
            <template #default="{ row }">
              <span class="name-col" v-if="(row.category === 'Month' && row.workScoreInfo) || (row.category === 'Year' && row.yearScoreInfo)" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="185" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <span v-if="row.isRatingCurnt">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70"></vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.table.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="ongoing" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>
      <!-- 年计划考核 -->
      <div class='table-content' v-show="currentTab === 1">
        <div class="collapse" @click="yearCollapse($refs.table1)" :style="{'right': yearCollapseRight}">
          <i :class="[isYearCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table1"
          :edit-rules="validRules"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" min-width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="185" title="姓名">
            <template #default="{ row }">
              <span class="name-col" v-if="row.yearScoreInfo" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="185" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <span v-if="row.isRatingCurnt">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70"></vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.table.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="ongoing" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <!-- 折叠分数 -->
          <vxe-table-column
            v-for="classifyColumn in workClassifyColumns"
            :field="classifyColumn.field"
            width="110"
            :title="classifyColumn.name"
            :edit-render="{enabled: classifyColumn.editable, autofocus: '.el-input__inner'}"
            :visible="isShowYearPlan"
            :key="classifyColumn.field"
            fixed="right"
          >
            <template #edit="{ row }">
              <el-input v-model.trim="row[classifyColumn.field]" @change="validateScore(row, classifyColumn.field)"></el-input>
            </template>
            <template #default="{row}">
              <div>{{row[classifyColumn.field]}}</div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>

      <!-- 员工绩效参考 -->
      <div class='table-content' v-show="currentTab === 2">
        <div class="collapse" @click="personCollapse($refs.table2)" :style="{'right': personCollapseRight}">
          <i :class="[isPersonCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table2"
          :edit-rules="validRules"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" min-width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="wkName" min-width="185" title="姓名">
            <template #default="{ row }">
              <span class="name-col" v-if="row.workScoreInfo" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
              <span v-else>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" min-width="185" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="isRatingCurnt" title="是否参评" width="80">
            <template #default="{row}">
              <span v-if="row.isRatingCurnt">是</span>
              <span v-else>否</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="score" title="总成绩" width="70"></vxe-table-column>

          <vxe-table-column width="90" field="ratingResult" title="评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.table.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.ratingReason }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="ongoing" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <!-- 折叠分数 -->
          <vxe-table-column field="classify100" width="80" title="绩效成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #edit="{ row }">
              <el-input v-model.trim="row.classify100" @change="validateScore(row, 'classify100')"></el-input>
            </template>
            <template #default="{row}">
              <div>{{row.classify100}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify110" width="80" title="企业文化导向成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #edit="{ row }">
              <el-input v-model.trim="row.classify110" @change="validateScore(row, 'classify110')"></el-input>
            </template>
            <template #default="{row}">
              <div>{{row.classify110}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify120" width="80" title="个人成长成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #edit="{ row }">
              <el-input v-model.trim="row.classify120" @change="validateScore(row, 'classify120')"></el-input>
            </template>
            <template #default="{row}">
              <div>{{row.classify120}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify130" width="80" title="OEC综合成绩" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify130}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-for="col in monthColumns"
            :field="col.field"
            :width="col.width"
            :title="col.title"
            :fixed="col.fixed"
            :visible="isShowPerson"
            :key="col.field"
            class-name='col-small'
            header-class-name='col-small'
          >
          </vxe-table-column>
        </vxe-table>

      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          v-show="currentTab === 0"
          background
          :current-page.sync="page.pageIndex"
          :page-size.sync="page.pageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 1"
          background
          :current-page.sync="yearPage.pageIndex"
          :page-size.sync="yearPage.pageSize"
          :total="yearTotal"
          height="100%"
          @page-change="yearPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 2"
          background
          :current-page.sync="personPage.pageIndex"
          :page-size.sync="personPage.pageSize"
          :total="personTotal"
          height="100%"
          @page-change="personPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="isShowCommitTip" width="300px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要提交吗?</h2>
        <p>提交之后不能修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowCommitTip = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showAccess"
      width="500px"
      @close="closeAccess"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" :maxlength="$config.input.textareaMaxLength" placeholder="请填写审批通过原因" v-model="approveReason"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="approve('access')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showAccess = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showRefuse"
      width="500px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <el-input type="textarea" :autosize="{ minRows: 5 }" :maxlength="$config.input.textareaMaxLength"  placeholder="请填写审批驳回原因" v-model="approveReason"> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="approve('refuse')">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showRefuse = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审批意见"
      :visible.sync="showApproveReason"
      width="500px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <p style="text-align:left;line-height: 18px;">{{approveReasonText || '无'}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-cancel" type="primary" @click="showApproveReason = false">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="showRevert"
      width="300px"
      @close="closeRefuse"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content">
        <h2>确定要撤回当前申报吗?</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="revert()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showRevert = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="isShowImportantSort" width="260px">
      <div class="content sub-content">
        <h2>请继续完成重要度排序！</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="toImportantSort">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowImportantSort = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {
    CLASSIFY_MAP,
    EDITDABLE_CLASSIFY,
    PERIODS,
    PERIOD_LIST,
    OEC_LEVEL,
    IMPORTANCE_STATE
  } from '@/utils/period-enum.js';
  import workscoreMixin from '@/mixins/workscore.mixin.js';

  export default {
    name: "periodResult",
    components: {
      selecter: () => import('@/component/global/customerSelect'),
    },
    mixins: [ workscoreMixin ],
    inject: ['reload'],
    data() {
      const ratingReasonValid = ({cellValue, row}) => {
        if (!cellValue && ['A', 'C'].includes(row.ratingResult) && [0, 10].includes(row.status)) {
          return new Error('评级结果为A、C时必须填写原因！')
        }
      }
      return {
        validRules: {
          ratingReason: [
            { validator: ratingReasonValid }
          ]
        },
        tabs: [
          { name: '全部', value: 0, key: 'all', category: '' },
          { name: '年计划考核', value: 1, key: 'year', category: 'Year' },
          { name: '员工绩效考核', value: 2, key: 'person', category: 'Month' },
        ],
        currentTab: 0,
        isYearCollapse: true,
        isPersonCollapse: true,
        yearCollapseRight: 0,
        personCollapseRight: 0,

        classifyMap: CLASSIFY_MAP,
        editableClassify: EDITDABLE_CLASSIFY,
        
        periods: PERIODS,
        periodList: PERIOD_LIST,
        oecLevel: OEC_LEVEL,

        declareForm: {
          wkNo: '',
        },
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        total: 0,
        tableData: [],

        yearPage: {
          pageIndex: 1,
          pageSize: 10
        },
        yearTotal: 0,

        personPage: {
          pageIndex: 1,
          pageSize: 10
        },
        personTotal: 0,

        currentSum: {},
        warnNum: 'warn-num',
        nomalNum: 'num',

        statusMap: IMPORTANCE_STATE,
  
        isShowCommitTip: false,
        
        cacheEditJson: {},
        cacheEditClassifyJson: {},
        errMap: 1,
        
        currWkNo: '',
        wkNo: '',
        msgId: '',
        role: 1,

        showAccess: false,
        showRefuse: false,
        showRevert: false,
        showApproveReason: false,
        approveReason: '',
        approveReasonText: '',

        isShowYearPlan: false,
        isShowPerson: false,
        monthColumns: [
          {field: 'm1', title: '1月',  width: 35, fixed: 'right'},
          {field: 'm2', title: '2月',  width: 35, fixed: 'right'},
          {field: 'm3', title: '3月',  width: 35, fixed: 'right'},
          {field: 'm4', title: '4月',  width: 35, fixed: 'right'},
          {field: 'm5', title: '5月',  width: 35, fixed: 'right'},
          {field: 'm6', title: '6月',  width: 35, fixed: 'right'},
          {field: 'm7', title: '7月',  width: 35, fixed: 'right'},
          {field: 'm8', title: '8月',  width: 35, fixed: 'right'},
          {field: 'm9', title: '9月',  width: 35, fixed: 'right'},
          {field: 'm10', title: '10月',  width: 40, fixed: 'right'},
          {field: 'm11', title: '11月',  width: 40, fixed: 'right'},
          {field: 'm12', title: '12月',  width: 40, fixed: 'right'},
        ],

        classifyPrefix: 'classify',

        isApprove: false,

        isShowImportantSort: false,

        isDynamicEffective: true, // 是否启用动态版本

        workClassifyColumns: [],
      }
    },
    created() {
      this.wkNo = this.$route.query.wkNo || '';
      this.msgId = this.$route.query.msgId || '';
      this.role = this.$route.query.role || 1;
      this.isApprove = this.$route.query.editStatus || false;
    },
    mounted() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';

      this.getDynamicClassify({});
      this.getList();
    },
    methods: {
      switchTab(tabIndex) {
        this.currentTab = tabIndex;
        this.getList();
      },
      yearCollapse(el) {
        this.isYearCollapse = !this.isYearCollapse;
        if (this.isYearCollapse) {
          this.hideYearPlan();
        } else {
          this.showYearPlan();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setYearPosition();
        });
      },
      showYearPlan() {
        this.isShowYearPlan = true;
      },
      hideYearPlan() {
        this.isShowYearPlan = false;
      },
      setYearPosition() {
        setTimeout(() => {
          if (this.isYearCollapse) {
            this.yearCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table1.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
            this.yearCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },

      personCollapse(el) {
        this.isPersonCollapse = !this.isPersonCollapse;
        if (this.isPersonCollapse) {
          this.hidePerson();
        } else {
          this.showPerson();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setPersonPosition();
        });
      },
      showPerson() {
        this.isShowPerson = true;
      },
      hidePerson() {
        this.isShowPerson = false;
      },
      setPersonPosition() {
        setTimeout(() => {
          if (this.isPersonCollapse) {
            this.personCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table2.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
            this.personCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },

      validateScore(row, field) {
        let val = row[field];
        if(!val) val = '';
        val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        val = val && parseFloat(val);
        if (val - 0 > 100) {
          val = 100;
        }
        if (val - 0 < 0) {
          val = 0;
        }
        row[field] = val;
      },

      getCurrRateSum() {
        return new Promise(resolve => {
          let param = Object.assign({loginWkNo: this.currWkNo}, this.declareForm, this.page)
          this.$ajax.post(this.$api.period.resultDeclare.rate, param).then((res) => {
            res.data ? resolve(res.data) : resolve({});
          });
        });
      },
      async getList(resetPage) {
        if (resetPage) {
          this.page.pageIndex = 1;
          this.yearPage.pageIndex = 1;
          this.personPage.pageIndex = 1;
        }
        if (this.wkNo) {
          this.currWkNo = this.wkNo;
        }
        let page = this.page;
        switch (this.currentTab) {
          case 0:
            page = this.page;
            break;
          case 1:
            page = this.yearPage;
            break;
          case 2:
            page = this.personPage;
            break;
          default:
            break;
        }
        let tab = this.tabs.find(item => item.value === this.currentTab);
        let category = tab ? tab.category : '';
        let year = this.$route.query.year || undefined;
        let period = this.$route.query.period || undefined;
        let param = Object.assign({loginWkNo: this.currWkNo, Category: category, year, period}, this.declareForm, page);
        await this.$ajax.post(this.$api.period.resultDeclare.list, param).then(async (res) => {
          let resList = res.data.rows || [];
          let tableDatas = [];
          resList.forEach(item => {
            let rowData = {
              ...item.periodResultInfo,
              ...item,
            };
            let monthData = item.oecResultInfo || [];

            for (let i = 0; i < this.monthColumns.length; i++) {
              rowData[this.monthColumns[i]] = '';
            }
            monthData.forEach(p => {
              rowData['m' + p.month] = p.ratingResult || '';
            });

            let classifyData = item.periodClassifyScoreInfo || [];
            for (const key in this.classifyMap) {
              rowData[this.classifyPrefix + key] = '';
            }
            classifyData.forEach(c => {
              rowData[this.classifyPrefix + c.workClassify] = c.score;
            });

            tableDatas.push(rowData);
            
            if (this.currentTab === 1) {
              this.handleDynamicColumn(res.data.classifyList || []);
            }
          });
          this.tableData = tableDatas;
          if (this.tableData && this.tableData.length > 0) {
            this.approveReasonText = this.tableData[0].approveReason;
          }
          switch (this.currentTab) {
            case 0:
              this.total = res.data.total;
              break;
            case 1:
              this.yearTotal = res.data.total;
              break;
            case 2:
              this.personTotal = res.data.total;
              break;
            default:
              break;
          }
          this.currentSum = await this.getCurrRateSum();
        });
      },
      handleDynamicColumn(dynamicWorkClassify) {
        let workClassifyColumns = [];
        const defaultColumns = [
          {field: `${this.classifyPrefix}0`, editable: true, workClassify: 0, name: '重要KPI成绩' },
          {field: `${this.classifyPrefix}10`, editable: true, workClassify: 10, name: '业务成绩' },
          {field: `${this.classifyPrefix}20`, editable: false, workClassify: 20, name: '费效管理成绩' },
          {field: `${this.classifyPrefix}30`, editable: false, workClassify: 30, name: '人力资源管理成绩' },
          {field: `${this.classifyPrefix}40`, editable: false, workClassify: 40, name: '企业文化管理成绩' },
        ];
        if (dynamicWorkClassify.length > 0) {
          workClassifyColumns = dynamicWorkClassify.map((item) => {
            return {
              field: `${this.classifyPrefix}${item.workClassify}`,
              editable: ![2, 3].includes(item.type),
              workClassify: item.workClassify,
              name: item.classifyName
            }
          })
        } else {
          workClassifyColumns = defaultColumns;
        }
        this.workClassifyColumns = workClassifyColumns;
      },
      // 判断是否可编辑，聚焦缓存行快照
      editActived({row}) {
        if (this.isApprove) {
          return false
        }
        if (row.tag === 1 && this.errMap) {
          const preVal = {ratingResult: row.ratingResult, ratingReason: row.ratingReason, remarks: row.remarks};
          this.cacheEditJson = JSON.parse(JSON.stringify(preVal));

          // 折叠分数快照
          const preValClassify = {};
          this.editableClassify.forEach(key => {
            preValClassify[this.classifyPrefix + key] = '';
          });
          for (const key in row) {
            if (Object.hasOwnProperty.call(row, key) && preValClassify.hasOwnProperty(key)) {
              preValClassify[key] = row[key];
            }
          }
          this.cacheEditClassifyJson = JSON.parse(JSON.stringify(preValClassify));
          return true;
        }
        return false;
      },
      // 失焦保存行数据
      async editClosed({row}) {
        // console.log(row);
        //  $table.clearValidate();
        let $table = this.$refs.table;
        if (this.currentTab === 1) {
          $table = this.$refs.table1;
        } else if (this.currentTab === 2) {
          $table = this.$refs.table2;
        }

        this.errMap = null;
        const currVal = {ratingResult: row.ratingResult, ratingReason: row.ratingReason, remarks: row.remarks};
        
        if (JSON.stringify(this.cacheEditJson) === JSON.stringify(currVal)) {
          this.errMap = 1;
        } else {
          this.errMap = await $table.validate(row).catch(errMap => errMap)
          if (!this.errMap) {
            this.errMap = 1;
            const {id, ratingResult, ratingReason, remarks} = row;
            this.$ajax.put(this.$api.period.resultDeclare.update, {id, ratingResult, ratingReason, remarks}).then(async() => {
              this.$message.success("保存成功");
              this.currentSum = await this.getCurrRateSum();
            });
          }
        }

        // 折叠分数保存
        const currValClassify = {};
        this.editableClassify.forEach(key => {
          currValClassify[this.classifyPrefix + key] = '';
        });
        for (const key in row) {
          if (Object.hasOwnProperty.call(row, key) && currValClassify.hasOwnProperty(key)) {
            currValClassify[key] = row[key];
          }
        }
        // const classifyInfo = row.periodClassifyScoreInfo; // 接口数据，当前行的折叠分数信息
        // classifyInfo.find(info => info.workClassify === key);
        const changedClassify = [];
        this.editableClassify.forEach(key => {
          let currScore = currValClassify[this.classifyPrefix + key];
          if (this.cacheEditClassifyJson[this.classifyPrefix + key] !== currScore) {
            changedClassify.push({
              workClassify: key,
              score: (currScore || currScore === 0) ? currScore : null,
              wkNo: row.wkNo,
              wkName: row.wkName,
              year: row.year,
              period: row.period,
            });
          }
        });

        if (changedClassify.length === 0) {
          this.errMap = 1;
        } else {
          this.errMap = await $table.validate(row).catch(errMap => errMap)
          if (!this.errMap) {
            this.errMap = 1;
            if (this.currentTab === 1) {
              this.$ajax.post(this.$api.period.resultDeclare.updateMultiYearScore, changedClassify).then((res) => {
                this.$message.success("保存成功");
                row.score = res.data;
              });
            } else {
              this.$ajax.put(this.$api.period.resultDeclare.updateScore, changedClassify).then((res) => {
                this.$message.success("保存成功");
                row.score = res.data.periodResultInfo.score;
              });
            }
          }
        }
      },
      
      commitTip() {
        this.$nextTick(async () => {
          let $table = this.$refs.table;
          if (this.currentTab === 1) {
            $table = this.$refs.table1;
          } else if (this.currentTab === 2) {
            $table = this.$refs.table2;
          }
          const errMap = await $table.validate(true).catch(errMap => errMap)
          if (!errMap) {
            this.isShowCommitTip = true;
          }
        })
      },
      submit() {
        this.$ajax.put(this.$api.period.resultDeclare.commit).then(() => {
          this.getList().then(async() => {
            this.currentSum = await this.getCurrRateSum();
          });
          this.$message.success("提交成功");
          this.judgeImportantSort();
        }).finally(() => {
          this.isShowCommitTip = false;
        });
      },
      revert() {
        this.showRevert = false;
        this.$ajax.put(this.$api.period.resultDeclare.revert).then(() => {
          this.getList();
          this.$message.success("撤回成功");
        });
      },
      pageChange({currentPage}) {
        this.page.pageIndex = currentPage;
        this.getList();
      },
      yearPageChange({currentPage}) {
        this.yearPage.pageIndex = currentPage;
        this.getList();
      },
      personPageChange({currentPage}) {
        this.personPage.pageIndex = currentPage;
        this.getList();
      },
      toPage(row) {
        if (row.category === 'Month') {
          this.$router.push({path: '/personal/workscore/detail', query: { id: row.workScoreInfo.id, editStatus: 'approve' }});
        } else if (row.category === 'Year') {
          let pagePath = '/personal/workscore/yearDetail';
          if (this.isDynamicEffective && row.yearScoreInfo.versionId) {
            pagePath = '/personal/workscore/yearDetailNext';
          }
          this.$router.push({path: pagePath, query: { id: row.yearScoreInfo.id, editStatus: 'approve' }});
        }
      },

      approve(action) {
        let param = {
          msgId: this.msgId,
          status: 0,
          remark: this.approveReason
        };
        if (action === "access") {
          param.status = 30;
          this.showAccess = false;
        } else {
          param.status = 10;
          if (!this.approveReason) {
            this.$message.error('"驳回原因"为必填项');
            return false;
          }
          this.showRefuse = false;
        }
        this.$ajax.put(this.$api.period.resultDeclare.updateStatus, param).then(() => {
          this.$message.success("审批成功");
          this.reload();
        });
      },
      closeRefuse() {
        this.approveReason = '';
      },
      closeAccess() {
        this.approveReason = '';
      },

      expandRow({ rowIndex }) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        let $table = this.$refs.table;
        if (this.currentTab === 1) {
          $table = this.$refs.table1;
        } else if (this.currentTab === 2) {
          $table = this.$refs.table2;
        }
        $table.updateData(this.tableData);
      },
      exportExcel() {
        let tab = this.tabs.find(item => item.value === this.currentTab);
        let category = tab ? tab.category : '';
        let param = Object.assign({loginWkNo: this.currWkNo, category: category}, this.declareForm);
        this.$ajax.post(this.$api.period.resultDeclare.exportDeclare, param, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = '综合结果申报'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
       // 提交后判断重要度排序是否完成提交
       judgeImportantSort() {
        let menuObj = JSON.parse(sessionStorage.getItem('btn_auth') || '{}');
        if (!menuObj['OEC.Period.ImportantSort']) {
          return false;
        }
        let param = {LoginWkNo: this.currWkNo, pageIndex: 1, pageSize: 9999 };
        this.$ajax.get(this.$api.period.importanceSort.search, param).then((res) => {
          let resList = res.data.rows.importantSort || [];
          for (let i = 0; i < resList.length; i++) {
            const item = resList[i];
            if (item.status === 0 || item.status === 10) {
              this.isShowImportantSort = true;
              return false;
            }
          }
        });
      },
      toImportantSort() {
        this.$router.push('/period/importance-sort/index');
      },

    },
    watch: {
      $route(){
        this.reload();
      },
    }
  }
</script>
<style scoped lang='scss'>
  .declare-page {
    height: 100%;
    .search-wrap {
      .atb-input {
        display: flex;
        .form-param-item {
          width: 20%;
          ::v-deep .el-form-item__content {
            width: calc(100% - 50px);
            .customerSelect {
              width: 100%;
            }
          }
        }
      }
    }
    .search {
      .atb-input {
        display: flex;
        flex-direction: column;
        .query-where {
          display: flex;
          .flex-form-item {
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
        }
      }
    }
    .table-content {
      position: relative;
    }
    .atb-content-bg {
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab {
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    .summary {
      font-size: 14px;
      line-height: 1;
      color: #4a5150;
      .item-data {
        margin: 0 40px 12px 0;
        display: inline-block;
        .cursor{
          cursor: pointer;
        }
        .num {
          font-weight: bolder;
          color: #22b6a1;
          padding: 0 10px;
        }
        .warn-num {
          font-weight: bolder;
          color: #fe6562;
          padding: 10px;
        }
      }
    }
  }
  .name-col {
    cursor: pointer;
    color: $--color-primary;
  }
  .collapse {
    margin-top: -15px;
    position: absolute;
    top: 50%;
    right: 0;
    width: 15px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: rgba(#000, 0.1);
    z-index: 99;
    cursor: pointer;
    &:hover {
      background-color: rgba(#000, 0.2);
    }
    i {
      font-size: 14px;
      color: #fff;
    }
  }
  .table-tabs {
    .table-tab {
      display: inline-block;
      margin: 0 8px 12px;
      padding: 8px 10px;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      border: 1px solid $--color-primary;
      background-color: #d8f5f1;
      color: $--color-primary;
      &:hover, &.table-tab--active {
        background-color: $--color-primary;
        color: #fff;
      }
    }
    
  }
</style>